import {Injectable} from '@angular/core';
import {UtilityService} from '@irb/irb-common/services/utility.service';
import {ISecurityMasterAssetClass} from '@irb/irb-models/irb-models.model';
import {SecurityMasterService} from '@irb/irb-models/security-master/security-master.service';
import {IFilterModel} from '@irb/app.model';
import {AppService} from '@irb/app.service';
import {IDropdownItem} from "@irb-common/models/dropdown.model";

@Injectable({providedIn: 'root'})
export class SecurityMasterAssetCategoryService {
    assetClassesLevel1: Array<ISecurityMasterAssetClass>;
    assetClassesLevel2: Array<ISecurityMasterAssetClass>;
    assetClassesLevel3: Array<ISecurityMasterAssetClass>;
    assetClassesLevel4: Array<ISecurityMasterAssetClass>;

    constructor(
        private sms: SecurityMasterService, 
        private util: UtilityService, 
        private as: AppService
    ) {}

    getAllAssetClasses(cbFunc: Function) {
        this.sms.getACLevels().subscribe((resp: any) => {
            let r = resp.data.irebalResponse;;
            this.assetClassesLevel1 = r?.acLevel1 || [];
            this.assetClassesLevel2 = r?.acLevel2 || [];
            this.assetClassesLevel3 = r?.acLevel3 || [];
            this.assetClassesLevel4 = r?.acLevel4 || [];

            let a = this.assetClassesLevel1.concat(this.assetClassesLevel2.concat(this.assetClassesLevel3.concat(this.assetClassesLevel4)));
            a = this.util.sortByKey(a, 'label', 'asc');
            cbFunc(a);
        });
    }

    getAssetClasses(parent: any) {
        this.sms.getACLevels().subscribe((resp: any) => {
            let r = resp.data.irebalResponse;
            this.assetClassesLevel1 = r?.acLevel1 || [];
            this.assetClassesLevel1 = this.util.sortByKey(this.assetClassesLevel1, 'label', 'asc');

            this.assetClassesLevel2 = r?.acLevel2 || [];
            this.assetClassesLevel2 = this.util.sortByKey(this.assetClassesLevel2, 'label', 'asc');

            this.assetClassesLevel3 = r?.acLevel3 || [];
            this.assetClassesLevel3 = this.util.sortByKey(this.assetClassesLevel3, 'label', 'asc');

            this.assetClassesLevel4 = r?.acLevel4 || [];
            this.assetClassesLevel4 = this.util.sortByKey(this.assetClassesLevel4, 'label', 'asc');
            
            parent.params.api.getColumnFilterInstance('acLevel4').then((f: any) => {
              f.data = this.getDropdownOptionsForAssetClasses(this.assetClassesLevel4);
      
              let filterModel: IFilterModel = this.as.getFieldInfo(parent.applyFilterOnLanding, 'acLevel4');
      
              if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
                filterModel.isUpdatRequired = false;
                parent.applyFilterOnLanding.isUpdatRequired = false;
                
                f.values = f.getIDropdownItems([filterModel.value]);
                parent.params.api.setFilterModel({'acLevel4': { 'values': [filterModel.value]}});
                parent.params.api.onFilterChanged();
      
                if (!parent.hasServerSideDatasource) {
                  parent.params.api.setGridOption('serverSideDatasource', parent.setDatasource());
                }
              }  
            });     
        });
    }

    getDropdownOptionsForAssetClasses(assetClasses: Array<ISecurityMasterAssetClass>) {
        let d: IDropdownItem[] = [];
        
        assetClasses?.forEach((x: ISecurityMasterAssetClass) => {
          d.push({name: x.label, value: x.code} as IDropdownItem);
        });

        return d;
    }

    getCellDisplayForAssetClasses(assetClasses: Array<ISecurityMasterAssetClass>) {
        let d: IDropdownItem[] = [];
        
        assetClasses?.forEach((x: ISecurityMasterAssetClass) => {
          d.push({names: [x.label, x.allocation + "%"], value: x.code} as IDropdownItem);
        });

        return d;
    }
}